import CloseIcon from '@mui/icons-material/Close'
import { Box, Drawer, IconButton, Stack } from '@mui/material'
import { FC } from 'react'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { ShiftDrawerShiftList } from './ShiftDrawerShiftList'
import type { ShiftCellAssignment } from './ShiftScheduleGrid'
import { isPastScheduleDate } from './shiftScheduleLayout'

interface ShiftDayDetailsDrawerProps {
	open: boolean
	employeeName: string
	assignments: ShiftCellAssignment[]
	onClose: () => void
	onDeleteShift: (assignment: ShiftCellAssignment) => void
}

export const ShiftDayDetailsDrawer: FC<ShiftDayDetailsDrawerProps> = ({
	open,
	employeeName,
	assignments,
	onClose,
	onDeleteShift,
}) => {
	const canDeleteShifts =
		assignments.length > 0 && !isPastScheduleDate(assignments[0].date)
	const shiftsTitle = canDeleteShifts
		? 'Запланированные смены'
		: 'Выполненные смены'

	return (
		<Drawer
			anchor='right'
			open={open}
			onClose={onClose}
			PaperProps={{
				sx: {
					width: '520px',
					maxWidth: '100vw',
					p: '24px',
				},
			}}
		>
			<Stack direction='column' gap='24px'>
				<Stack
					direction='row'
					justifyContent='space-between'
					alignItems='flex-start'
				>
					<TypographyPrimary
						sx={{ fontSize: '24px', fontWeight: 700, lineHeight: 1.2 }}
					>
						{employeeName}
					</TypographyPrimary>
					<IconButton onClick={onClose} size='small' sx={{ mt: '-4px' }}>
						<CloseIcon sx={{ fontSize: '24px', color: '#7F7F84' }} />
					</IconButton>
				</Stack>

				<Box>
					<TypographyPrimary
						sx={{ fontSize: '16px', fontWeight: 700, mb: '14px' }}
					>
						{shiftsTitle}
					</TypographyPrimary>
					<ShiftDrawerShiftList
						assignments={assignments}
						showDelete={canDeleteShifts}
						onDelete={onDeleteShift}
					/>
				</Box>
			</Stack>
		</Drawer>
	)
}
